///////////// PRODUCTOS ////////////////

import { apiBasic, apiGet, apiToken } from "./requests";

// Crear producto
export const createProduct = (data) => {
  let path = "product/";
  return apiBasic(data, path, "post");
};

// Editar producto
export const updateProduct = (productId, data) => {
  let path = `product/${productId}`;
  return apiBasic(data, path, "patch");
};

// Agregar categorías a producto
export const addCategoriesToProduct = (productId, categoryIds) => {
  let path = `product/${productId}/add-to-categories`;
  return apiToken({ categoryIds }, path, "post");
};

// Agregar catálogos a producto
export const addCatalogsToProduct = (productId, catalogIds) => {
  let path = `product/${productId}/add-to-catalogs`;
  return apiToken({ catalogIds }, path, "post");
};

// Actualizar categorías a producto
export const updateCategoriesToProduct = (productId, categoryIds) => {
  let path = `product/${productId}/update-categories`;
  return apiBasic({ categoryIds }, path, "patch");
};

// Actualizar catálogos a producto
export const updateCatalogsToProduct = (productId, catalogIds) => {
  let path = `product/${productId}/update-catalogs`;
  return apiBasic({ catalogIds }, path, "post");
};

// Obtener productos de una corporación
export const getProduct = (productId) => {
  let path = `product/${productId}`;
  return apiGet(path);
};

// Obtener productos de una corporación
export const getProducts = () => {
  let path = "products/";
  return apiGet(path);
};

export const getProductsWithOrganization = () =>
  apiGet("products/", { includeOrganization: true });

// Obtener productos no completados
export const getIncompleteProducts = () => {
  let path = "products/not-completed";
  return apiGet(path);
};

// Eliminar productos por lote
export const deleteProductsBatch = (productIds) => {
  console.log("deleteProductsBatch", productIds);
  let path = "products/delete-batch";
  return apiBasic({ productIds }, path, "delete");
};

// Cambiar el estado de un producto
export const updateProductStatus = (productId, status) => {
  console.log("updateProductStatus", productId, status);
  let path = `product/${productId}/status`;
  return apiBasic({ status }, path, "patch");
};

export const getAlergens = () => {
  let path = "allergens/";
  return apiGet(path);
};

export const updateAlergens = (productId, data) => {
  let path = `product/${productId}/add-allergens`;
  return apiBasic(data, path, "patch");
};

/*export const getAttributes = () => {
  let path = "attributes/";
  return apiGet(path);
};*/

export const getAttributes = (productId) => {
  let path = `product/${productId}/items`;
  return apiGet(path);
};

export const updateAttributes = (productId, data) => {
  let path = `product/${productId}/add-attributes`;
  return apiBasic(data, path, "patch");
};

/* ATRIBUTOS */

// DELETE /product/{productId}/remove-item-group/{itemGroupId}
// Eliminar/desactivar grupo completo activo
export const adminRemoveItemGroupFromProduct = (productId, itemGroupId) => {
  let path = `product/${productId}/remove-item-group/${itemGroupId}`;
  return apiBasic({}, path, "delete");
};

// DELETE /product/{productId}/remove/{itemGroupId}/item/{itemId}
// Eliminar item de un grupo activo
export const adminRemoveItemFromProductGroup = (
  productId,
  itemGroupId,
  itemId,
) => {
  let path = `product/${productId}/remove/${itemGroupId}/item/${itemId}`;
  return apiBasic({}, path, "delete");
};

// PATCH /product/{productId}/add-item-groups
// Añadir grupo completo que no está activo
// Body: { itemGroups: [ { itemGroupId, itemIds: [] } ] }  (o lo que soporte tu backend)
export const adminAddItemGroupsToProduct = (productId, data) => {
  let path = `product/${productId}/add-item-groups`;
  return apiBasic(data, path, "patch");
};

// PATCH /product/{productId}/add-item-group/{itemGroupId}
// Añadir grupo personalizado que no esté activo
// Body: { items: ["string"] } (según swagger)
export const adminAddCustomItemGroupToProduct = (
  productId,
  itemGroupId,
  data,
) => {
  let path = `product/${productId}/add-item-group/${itemGroupId}`;
  return apiBasic(data, path, "patch");
};

// (alias) Añadir grupo personalizado
export const addAttributesItems = (productId, itemGroupId, data) => {
  let path = `product/${productId}/add-item-group/${itemGroupId}`;
  return apiBasic(data, path, "patch");
};

// (alias) Eliminar/desactivar grupo completo activo
export const removeAttributesItems = (productId, itemGroupId) => {
  let path = `product/${productId}/remove-item-group/${itemGroupId}`;
  return apiBasic({}, path, "delete");
};

// (alias) Añadir grupo completo que no está activo
export const updateAttributesGroup = (productId, itemGroupId, data) => {
  let path = `product/${productId}/add-item-groups`;
  return apiBasic(data, path, "patch");
};

/* VARIANTES */

export const getVariants = (productId) => {
  let path = `product/${productId}/variants`;
  return apiGet(path);
};

export const toogleVariant = (varianId) => {
  let path = `variant/${varianId}/toggle-status`;
  return apiBasic({}, path, "patch");
};

// Actualizar variante (es unica por producto)
export const updateVariant = (varianId, data) => {
  let path = `variant/${varianId}/`;
  return apiBasic(data, path, "patch");
};

//Borrar todas las variantes de un producto
export const deleteAllVariants = (productId) => {
  let path = `product/${productId}/delete-variants`;
  return apiBasic({}, path, "delete");
};

//Borrado (logico) de una variante de un producto
export const deleteVariant = (productId, variantId) => {
  let path = `product/${productId}/variant/${variantId}`;
  return apiBasic({}, path, "delete");
};
